import React, { useEffect, useState } from 'react';
import Dashboard from '../../components/Dashboard';
import MenuContainer from '../../components/custom-components/menu/MenuContainer';
import AdaptiveContainer from '../../components/containers/AdaptiveContainer';
// Removed unused import
import { GetMe } from '../../graphql/queries/GetMe';
import { useError } from '../../error-provider/ErrorProvider';
import { useLazyQuery } from '@apollo/client';
import { useRequireSubscription } from '../../hooks/useRequireSubscription';

const AutomationTemplate = () => {
    const { showError } = useError();
    // Redirect if user has no subscription
    useRequireSubscription();
    const mainStyles = {
        '@media only screen and (min-width: 465px)': {
            width: '96%',
        },

        '@media only screen and (max-width: 920px)': {
            width: '100%',
            paddingTop: '80px',
        },

        '@media only screen and (max-width: 450px)': {
            paddingTop: '0px',
            width: '345px',
        },
        '@media only screen and (min-width: 1750px)': {
            width: '1400px',
        },
    };

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');

    const [fetchMe] = useLazyQuery(GetMe, {
        onCompleted(data) {
            if (data?.getMe) {
                const { firstName, email, lastName } = data?.getMe;
                setFirstName(firstName);
                setLastName(lastName);
                setEmail(email);
            }
        },
        onError(error) {
            showError(undefined, error);
        },
    });

    useEffect(() => {
        fetchMe();
    }, [fetchMe]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            console.log('resize error');
        });

        resizeObserver.observe(document.body);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <Dashboard title='dashboard'>
            <MenuContainer>
                <AdaptiveContainer mt='100px' pl='10px' css={{ ...mainStyles }}>
                    <zapier-full-experience
                        sign-up-email={email}
                        sign-up-first-name={firstName}
                        sign-up-last-name={lastName}
                        client-id='aDpBckrfOZqJ8aZaiCUwbjOzWnPxTld1vI9Ndywe'
                        theme='light'
                        app-search-bar-display='show'
                    />
                </AdaptiveContainer>
            </MenuContainer>
        </Dashboard>
    );
};

export default AutomationTemplate;
